import '../styles/UserQuestion.scss';
import * as React from 'react';
import { CloseButton } from 'react-bootstrap';
import bind from 'bind-decorator';
import { getLocalization } from '../../../global/global';
import { ConfirmationModal } from '../../../views/Modals/ConfirmationModal';
import { SingleInstanceComponentClass } from '../SingleInstanceComponent';


interface Props {
  singleInstance: SingleInstanceComponentClass;
}

interface State {
  confirm: boolean;
}

export default class CloseButtonClass extends React.Component <Props, State> {

  constructor(props) {
    super(props);
    this.state = {
      confirm: false
    };
  }

  @bind
  private onClose() {
    const { singleInstance } = this.props;
    if (singleInstance.formComponent.current && singleInstance.formComponent.current.getUpdated()) {
      this.setState({ confirm: true });
    } else {
      singleInstance.unrender();
    }
  }

  @bind
  private closeConfirmed() {
    this.closeAlert();
    this.props.singleInstance.unrender();
  }

  @bind
  private closeAlert() {
    this.setState({ confirm: false });
  }

  public render(): JSX.Element {
    return (
      <React.Fragment>
        { this.state.confirm ? (
          <ConfirmationModal
            onConfirm={this.closeConfirmed}
            onClose={this.closeAlert}
            localizations={
              {
                cancel: getLocalization('cancel'),
                confirm: getLocalization('ok'),
                confirmStyle: 'danger',
                header: (
                  <label>{getLocalization('confirm')}</label>
                ),
                body: (
                  <div>{getLocalization('poiChangesAlert')}</div>
                )
              }
            }
          />
        )
          : null }
        <CloseButton data-testid={'close-btn'} onClick={this.onClose} />
      </React.Fragment>
    );
  }
}
